/*
 * @providesModule StaticCashDisabledModalStyle
 * 
 */

import SkillzStyle from 'SkillzStyle';
import Sizes from 'Sizes';

import {
  StyleSheet,
} from 'react-native';

const {
  fontRegular,
  fontSecondary,
  fontSizeH1,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  btnTextColorOne,
} = SkillzStyle.fullStyles;

export default StyleSheet.create({

  title: {
    ...Sizes.select({
      smallPhone: fontSizeH4,
      largePhone: fontSizeH3,
      landscapeTablet: fontSizeH2,
      portraitTablet: fontSizeH1,
    }),
    ...fontSecondary,
    color: '#4A4A4A',
    textAlign: 'center',
    paddingHorizontal: 25,
    marginTop: 10,
    marginBottom: -50,
  },

  message: {
    ...Sizes.select({
      smallPhone: fontSizeH4,
      largePhone: fontSizeH4,
      landscapeTablet: fontSizeH2,
      portraitTablet: fontSizeH1,
    }),
    ...fontRegular,
    color: '#4A4A4A',
    paddingHorizontal: 25,
    textAlign: 'center',
    marginBottom: 17.5,
    marginHorizontal: 1,
  },
  
  buttonText: {
    ...fontSecondary,
    ...fontSizeH4,
    ...btnTextColorOne,
  },

  buttonContainer: {
    marginBottom: 10,
  },
});
